import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, errMsg, money } from "@/lib/api";

const Th = ({ children, right }) => <th className={`py-1.5 px-2 text-[11px] font-mono uppercase tracking-wider text-slate-500 ${right ? "text-right" : "text-left"}`}>{children}</th>;
const TITRE = { nuits: "Nuits Airbnb", th: "Taxes remises par Airbnb" };
const fmt = (mesure, v) => (mesure === "th" ? money(v) : `${v} nuit(s)`);

const Ligne = ({ r, i, mesure }) => (
  <tr className={`border-t border-slate-100 ${r.compte ? "" : "text-slate-400"}`} data-testid={`controle-detail-row-${i}`}>
    <td className="py-1 px-2 font-mono">{r.code}</td>
    <td className="px-2">{r.nom_client || "—"}{r.annulee && <span className="ml-1 text-amber-700">(annulée)</span>}{r.a_venir && <span className="ml-1 font-semibold text-sky-700" data-testid={`controle-detail-a-venir-${i}`}>à venir</span>}</td>
    <td className="px-2 tabular">{r.date_debut}</td>
    <td className="px-2 tabular">{r.date_fin || "—"}</td>
    {mesure === "th" ? <td className="px-2 text-right tabular">{money(r.brut)}</td> : null}
    <td className="px-2 text-right tabular font-semibold">{mesure === "th" ? money(r.th) : r.nuits}</td>
    <td className="px-2 tabular">{r.versement}{!r.compte && !r.a_venir && <span className="ml-1 text-amber-700">hors période</span>}{r.a_venir && <span className="ml-1 text-sky-700">prévu</span>}</td>
  </tr>
);

export const ControleDetail = ({ importId, logement, mesure }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    setD(null);
    api.get(`/imports/${importId}/detail`, { params: { logement, mesure } }).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
  }, [importId, logement, mesure]);
  if (err) return <p className="text-xs text-red-600" data-testid="controle-detail-error">{err}</p>;
  if (!d) return <Loader2 className="h-4 w-4 animate-spin text-emerald-700" />;
  return (
    <div className="mt-3 rounded-md bg-slate-50 p-3" data-testid="controle-detail">
      <p className="text-xs font-semibold mb-2">{TITRE[mesure]} · {d.logement} · du {d.debut} au {d.fin}</p>
      <div className="overflow-x-auto max-h-72">
        <table className="w-full text-xs">
          <thead><tr><Th>Code</Th><Th>Voyageur</Th><Th>Arrivée</Th><Th>Départ</Th>{mesure === "th" && <Th right>Revenus bruts</Th>}<Th right>{mesure === "th" ? "Taxes remises" : "Nuits"}</Th><Th>Versement</Th></tr></thead>
          <tbody>{d.reservations.map((r, i) => <Ligne key={r.code} r={r} i={i} mesure={mesure} />)}</tbody>
        </table>
      </div>
      <p className="mt-2 text-xs" data-testid="controle-detail-total">
        Total application : <b>{fmt(mesure, d.application)}</b> · Airbnb : <b>{fmt(mesure, d.airbnb)}</b>
      </p>
      <p className="mt-1 text-xs text-slate-700" data-testid="controle-detail-note">{d.note}</p>
    </div>
  );
};
